(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    
    document.querySelectorAll('.faqs__question').forEach(btn => {
        btn.addEventListener('click', () => {
            const item = btn.closest('.faqs__item');
            const isOpen = item.classList.contains('open');
            document.querySelectorAll('.faqs__item.open').forEach(el => el.classList.remove('open'));
            if (!isOpen) item.classList.add('open');
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-blocks"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-featured-blocks-slider]').forEach(slider => {

        let flkty = null;

        function equalizeHeights() {
            if (!flkty) return;
            const slides = slider.querySelectorAll('[data-slide]');
            slides.forEach(slide => slide.style.height = '');
            const maxHeight = Math.max(...[...slides].map(s => s.offsetHeight));
            slides.forEach(slide => slide.style.height = maxHeight + 'px');
            flkty.resize();
        }

        function initSlider() {
            if (window.innerWidth <= 860 && !flkty) {
                flkty = new Flickity(slider, {
                    cellSelector: '[data-slide]',
                    cellAlign: 'left',
                    percentPosition: false,
                    wrapAround: true,
                    watchCSS: true,
                    pageDots: false,
                    prevNextButtons: false,
                });
                flkty.on('ready', equalizeHeights);
            } else if (window.innerWidth > 860 && flkty) {
                flkty.destroy();
                flkty = null;
                slider.querySelectorAll('[data-slide]').forEach(slide => slide.style.height = '');
            }
        }

        initSlider();
        window.addEventListener('load', () => {
            equalizeHeights();
            flkty && flkty.resize();
        });
        window.addEventListener('resize', () => {
            initSlider();
            equalizeHeights();
        });

    });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-slider"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-testimonial-slider]').forEach(slider => {
        const flkty = new Flickity(slider, {
            cellSelector: '[data-slide]',
            draggable: false,
            wrapAround: true,
            autoPlay: 7000,
            // fade: true,
            pauseAutoPlayOnHover: false,
            prevNextButtons: false,
        });

        // Recalc after all resources finish loading
        window.addEventListener('load', () => flkty.resize());
    });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-image-slider"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-text-image-slider]').forEach(slider => {
        const flkty = new Flickity(slider, {
            autoPlay: 5000,
            draggable: false,
            fade: true,
            cellSelector: '[data-slide]',
            pauseAutoPlayOnHover: false,
            prevNextButtons: false,
        });

        // Recalc after all resources finish loading
        window.addEventListener('load', () => flkty.resize());
    });
});


  } catch(e) { console.error(e); }
})();
})();
